import axios from "axios";

// Suporte a abort em diferentes versões do Axios / browsers:
var controllerSupported = (typeof AbortController !== "undefined");
var controller = controllerSupported ? new AbortController() : null;

// Para Axios mais antigo (CancelToken)
var hasCancelToken = !!axios.CancelToken;
var cancelSource = hasCancelToken ? axios.CancelToken.source() : null;

// Função global para abortar tudo (IdleManager chama isso)
function abortAllRequests() {
  try {
    if (controllerSupported && controller) {
      controller.abort();
    }
  } catch (e) {
    // noop
  }
  try {
    if (hasCancelToken && cancelSource) {
      cancelSource.cancel("abort");
      cancelSource = axios.CancelToken.source();
    }
  } catch (e2) {
    // noop
  }
  // recria o controller para próximas requisições
  controller = controllerSupported ? new AbortController() : null;
  return controller && controller.signal ? controller.signal : undefined;
}
window.__ABORT_ALL__ = abortAllRequests;

export const http = axios.create({
  withCredentials: true,
});

// Request interceptor
http.interceptors.request.use(function (config) {
  // Anexa abort (versões novas)
  if (controllerSupported && controller && !config.signal) {
    config.signal = controller.signal;
  }
  // Anexa CancelToken (versões antigas)
  if (hasCancelToken && cancelSource && !config.cancelToken) {
    config.cancelToken = cancelSource.token;
  }

  // Bearer token
  try {
    var token = localStorage.getItem("login");
    if (token) {
      config.headers = Object.assign({}, config.headers, { Authorization: "Bearer " + token });
    }
  } catch (e) {
    // noop
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// Response interceptor
http.interceptors.response.use(function (res) {
  return res;
}, function (err) {
  var status = err && err.response ? err.response.status : 0;
  if (status === 401 || status === 440) {
    abortAllRequests();
    try { localStorage.removeItem("login"); } catch (e) {}
    if (typeof window !== "undefined") {
      window.location.href = "/?reason=expired";
    }
  }
  return Promise.reject(err);
});
